import axios from 'axios';
import { getEnvVariables } from 'helpers/getEnvVariables';

const { QUOTER_URL } = getEnvVariables()

export const quoter = async (data) => {
    try {

        const response = await axios.post(`${QUOTER_URL}/rate-engine/compute`, data);
        return await response.data;

    } catch (error) {
        console.log(error?.response?.data?.message ?? error.message)
    }
};

/**
 * Igual que `quoter`, pero sin atrapar el error: lo necesita la validación de
 * planes favoritos (ver helpers/FavoritePlanValidation.js), que distingue un
 * 400 (beneficios obsoletos en el catálogo vigente) de un compute exitoso.
 */
export const computeQuote = async (data) => {
    const response = await axios.post(`${QUOTER_URL}/rate-engine/compute`, data);
    return response.data;
};

export const findQuoterByApQuoteId = async (apQuoteId) => {
    try {

        const response = await axios.get(`${QUOTER_URL}/rate-engine/compute/apQuoteId/${apQuoteId}?withContext=true`);
        return await response.data;

    } catch (error) {
        console.log(error.response.data.message)
    }
};
